import { Component } from "react";

/**
 * Catches any unhandled React render error and shows a minimal recovery UI
 * instead of a blank page. Logs the error so it appears in mobile console /
 * remote crash-reporting tools.
 */
export class RootErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error("[Radar] Uncaught render error:", error, info?.componentStack);
  }

  render() {
    const { error } = this.state;
    if (!error) return this.props.children;

    return (
      <div
        style={{
          maxWidth: "36rem",
          margin: "0 auto",
          padding: "2.5rem 1.25rem",
          fontFamily: "system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif",
          color: "#111827",
          lineHeight: 1.55,
        }}
      >
        <h1 style={{ fontSize: "1.5rem", fontWeight: 700, margin: "0 0 0.75rem" }}>
          Radar
        </h1>
        <p style={{ margin: "0 0 1rem", color: "#374151" }}>
          Competitor monitoring and intelligence for Shopify merchants.
        </p>
        <p style={{ margin: "0 0 1.5rem", fontSize: "0.9rem", color: "#6b7280" }}>
          Something went wrong loading the app. Please reload the page or open it in a
          different browser. If you keep seeing this,{" "}
          <a href="mailto:support@aquivolabs.com" style={{ color: "#2563eb" }}>
            contact support
          </a>
          .
        </p>
        <button
          onClick={() => window.location.reload()}
          style={{
            display: "inline-block",
            padding: "0.5rem 1.25rem",
            background: "#111827",
            color: "#fff",
            border: "none",
            borderRadius: "0.375rem",
            fontSize: "0.875rem",
            cursor: "pointer",
          }}
        >
          Reload
        </button>
        <p style={{ marginTop: "1.5rem", fontSize: "0.8125rem" }}>
          <a href="/privacy" style={{ color: "#2563eb", textDecoration: "underline" }}>
            Privacy Policy
          </a>
          <span style={{ margin: "0 0.4rem", color: "#9ca3af" }}>·</span>
          <a href="/terms" style={{ color: "#2563eb", textDecoration: "underline" }}>
            Terms of Service
          </a>
        </p>
        {process.env.NODE_ENV === "development" && (
          <pre
            style={{
              marginTop: "1.5rem",
              fontSize: "0.75rem",
              background: "#fef2f2",
              color: "#991b1b",
              padding: "0.75rem",
              borderRadius: "0.25rem",
              overflow: "auto",
              whiteSpace: "pre-wrap",
              wordBreak: "break-all",
            }}
          >
            {String(error)}{"\n\n"}{error?.stack || "(no stack)"}
          </pre>
        )}
      </div>
    );
  }
}
